import { Dialog } from '@angular/cdk/dialog';
import {EventEmitter, Injectable} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';
import { CommandService } from '@core/services/command.service';
import { FileManagementService } from '@core/services/file-management.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { Store } from '@ngrx/store';
import { PlatformCommand } from '@shared/commands/command-base';
import { SetCurrentRightSideComponentAction } from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import { PlatformSidebarState } from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler,
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { GridValueChangeEvent } from '@shared/models/common.models';
import { MagicLinkModel, TabModel } from '@shared/models/platform-tool-models';
import { QueryProvider } from '@shared/queries/query-provider';
import {DialogService} from '@shared/services/dialog-service';
import { IQueryState } from '@shared/store/reducers/query.reducer';
import { take } from 'rxjs';
import {Api} from "@shared/constants/common-field.constants";

@Injectable({
  providedIn: 'root'
})
export class PlatformToolDataExtractorHandler implements IPlatformToolHandler {

  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged = new EventEmitter<any>();
  metaData?: any;
  selectedTabModel: TabModel;
  activatedRoute?: ActivatedRoute;
  invalidateSubject: InvalidateSubject;

  constructor(
    private fuseSplashScreenService: FuseSplashScreenService,
    private commandService: CommandService,
    private snackBarService: SnackBarService,
    private router: Router,
    private queryStore: Store<IQueryState>,
    private platformSidebarStore: Store<PlatformSidebarState>,
    private fileManagementService: FileManagementService
  ) {
  }
  valueChanged($event: GridValueChangeEvent) {
    console.log('[Event]', $event);
    if ($event.action) {
      this.handleActions($event);
    }
    else if($event.fieldDefinition) {
      if (this.magicLinkModel.additionalCommands[$event.fieldDefinition.key]) {
        const command = this.magicLinkModel.additionalCommands[
          $event.fieldDefinition.key
        ];
        command.fieldValues['ItemId'] = $event.item.id;
        this.executeCommandToApi(command);
        return;
      }
      switch ($event.fieldDefinition.key) {
        default:
          this.openDataExtractorItem($event);
          break;
      }
    }
  }
  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
    if (selectedTab.tabData?.DetailsHelpId &&
      ((!this.magicLinkModel.fieldValues.hasOwnProperty('FlowId') || this.magicLinkModel.fieldValues.FlowId == null) && (!this.magicLinkModel.fieldValues.hasOwnProperty('NodeId') || this.magicLinkModel.fieldValues.NodeId == null))) {
      // ! [MAGIC-BAR-AUTO-OPEN]
      this.platformSidebarStore.dispatch(
        new SetCurrentRightSideComponentAction(
          { component: 'HelpNotesComponent', data: { isUserAction: false }, componentInfo: { id: 'HelpNotesComponent' } }));
    }
    this.invokeReferenceOptionsQuery();
  }
  destroy(): void {
    //throw new Error('Method not implemented.');
  }
  executeCommand(command: PlatformCommand, callBack?: any) {
    this.executeCommandToApi(command);
  }
  private handleActions($event: GridValueChangeEvent) {
    switch ($event.action.id) {
      case 'Open':
        this.openDataExtractorItem($event);
        break;
      case 'Delete':
        this.deleteDataExtractorItem($event);
        break;
      case 'Duplicate':
        this.duplicateDataExtractorItem($event);
        break;
      case 'Archive':
      case 'Unarchive':
        this.archiveDataExtractorItem($event);
        break;
    }
  }
  private executeCommandToApi(command: PlatformCommand) {
    console.log('[Executing PlatformCommand] -> ', command.name);
    command = JSON.parse(JSON.stringify(command));
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService
        .executePlatformCommand(command)
        .pipe(take(1))
        .subscribe(
          (res) => {
            console.log('Command Response', res);
            this.fuseSplashScreenService.hide();
            if (res.fieldValues['SnackBarMessage']) {
              const duration = res.fieldValues['SnackBarMessage'].length * 80;
              this.snackBarService.showInformation(
                res.fieldValues['SnackBarMessage'],
                duration
              );
            }
            if(command.name == 'AddEventSourceModelCommand'){
              var resumeWorokflowCommand = command.fieldValues['ResumeWorkflowCommand'];
              var eventSrcCommandName = command.fieldValues['EventSrcCommandName'];
              if(resumeWorokflowCommand && eventSrcCommandName == 'SyncWorkbookFromDataExtractorCommand'){
                this.executeCommand(resumeWorokflowCommand);
                return;
              }
            }
            if (res.fieldValues['RedirectUrl']) {
              const url = res.fieldValues['RedirectUrl'];
              const currentUrl = this.router.url;
              if (`/${url}` === currentUrl && res.fieldValues['Refresh']) {
                this.invalidateSubject.invalidate('Refresh');
              } else {
                this.router.navigateByUrl(url);
              }
              return;
            }
            if (res.fieldValues['RedirectCommand']) {
              var redirectCommand = res.fieldValues['RedirectCommand'];
              let redirectCommandName = redirectCommand.fieldValues['CommandName'];
              if(command.name == 'AddEventSourceModelCommand' && redirectCommandName == 'SyncWorkbookFromDataExtractorCommand'){
                var resumeWorokflowCommand = command.fieldValues['ResumeWorkflowCommand'];
                redirectCommand.fieldValues['ResumeWorkflowCommand'] = resumeWorokflowCommand;
                redirectCommand.fieldValues['EventSrcCommandName'] = redirectCommandName;
              }
              this.executeCommand(redirectCommand);
              return;
            }
            if (res.fieldValues['RedirectUrl']) {
              this.router.navigateByUrl(res.fieldValues['RedirectUrl']);
            }
            if (res.fieldValues['PlatformLinkModel']) {
              this.magicLinkModel = res.fieldValues['PlatformLinkModel'];
              this.magicLinkModelValueChangedHandler({
                id: 'PlatformToolContainerComponent', value: res.fieldValues['PlatformLinkModel'],
                magicLinkModel: this.magicLinkModel
              });
              return;
            }
            if (res.fieldValues['Reload'] && res.fieldValues['Reload'] === true) {
              this.invalidateReferenceOptions();
            }
            if (res.fieldValues['DownloadFileResponseModel']) {
              const downloadResponseModel = res.fieldValues['DownloadFileResponseModel'];
              const fileId = downloadResponseModel?.fileId;
              this.fileManagementService.downloadClientFileWithId(fileId).subscribe(payload => {
                this.fuseSplashScreenService.hide();
                this.fileManagementService.openSaveFileWindow(payload, downloadResponseModel.fileName);
              });
            }
            this.invalidateSubject.invalidate();
          },
          (error) => {
            console.error('Failed ToolBarComponent command', error);
            this.fuseSplashScreenService.hide();
          }
        );
    }
  }

  private magicLinkModelValueChangedHandler(command: any) {
    this.magicLinkModelValueChanged.emit(command);
  }
  private invokeReferenceOptionsQuery() {
    this.invalidateReferenceOptions();
  }
  private invalidateReferenceOptions() {
    const referenceOptionsQueryKey = this.magicLinkModel?.fieldValues['ReferenceOptionsQueryKey'];
    if (referenceOptionsQueryKey) {
      QueryProvider.invokeQuery(this.queryStore, referenceOptionsQueryKey, {});
    }
  }
  private openDataExtractorItem($event: GridValueChangeEvent) {
    const openCommand = this.magicLinkModel?.additionalCommands['Open'];
    if (!openCommand) {
      return;
    }
    let eventSourceId = $event.item.cells['EventSourceId'].value;
    openCommand.fieldValues['EventSourceId'] = eventSourceId;
    openCommand.fieldValues['DestinationTransportId'] = eventSourceId;
    openCommand.fieldValues['WorkbookSetId'] = eventSourceId;
    openCommand.fieldValues['IsEventSourceCommand'] = true;
    openCommand.fieldValues['EventSourceApi'] = Api.Spreadsheet;
    openCommand.fieldValues['SourceType'] = 'WorkbookSet';
    openCommand.fieldValues['DataExtractorItemId'] = $event.item.id;
    openCommand.fieldValues['ScenarioType'] = $event.item.cells['ScenarioType'].value;
    openCommand.fieldValues['DataExtractorConfigId'] = $event.item.cells['DataExtractorConfigId'].value;
    this.executeCommandToApi(openCommand);
  }
  private deleteDataExtractorItem($event: GridValueChangeEvent) {
    const deleteCommand = this.magicLinkModel?.additionalCommands['Delete'];
    if (!deleteCommand) {
      return;
    }
    deleteCommand.fieldValues['DataExtractorItemId'] = $event.item.id;
    this.executeCommandToApi(deleteCommand);
  }
  private duplicateDataExtractorItem($event: GridValueChangeEvent) {
    const duplicateCommand = this.magicLinkModel?.additionalCommands['Duplicate'];
    if (!duplicateCommand) {
      return;
    }
    duplicateCommand.fieldValues['DataExtractorItemId'] = $event.item.id;
    duplicateCommand.fieldValues['HasDialogInput'] = true;
    duplicateCommand.fieldValues['Title'] = $event.item.cells['Title'].value;
    duplicateCommand.fieldValues['DuplicateAction'] = true;

    this.executeCommandToApi(duplicateCommand);
  }
  private archiveDataExtractorItem($event: GridValueChangeEvent) {
    const archiveCommand = this.magicLinkModel?.additionalCommands[$event.action.id];
    if (!archiveCommand) {
      return;
    }
    archiveCommand.fieldValues['DataExtractorItemId'] = $event.item.id;
    this.executeCommandToApi(archiveCommand);
  }
}
